module.exports = __webpack_public_path__ + "assets/img/00007.40717614.png";